export default __webpack_public_path__ + "static/media/152.633a6972.jpg";